type ApiErrorPayload = {
  error?: unknown;
  error_description?: unknown;
  message?: unknown;
  response?: {
    data?: ApiErrorPayload;
  };
};

export function getCalendarReturnPath(
  state: string | null,
  success: boolean,
  errorMessage?: string
) {
  if (state === "onboarding") {
    return success ? "/onboarding?step=6" : "/onboarding?step=5";
  }

  const params = new URLSearchParams({ drawer: "calendar" });
  if (!success && errorMessage) {
    params.set("calendar_error", errorMessage);
  }

  return `/integrations?${params.toString()}`;
}

export function getCalendarCallbackErrorMessage(
  error: unknown,
  fallback: string
) {
  if (error && typeof error === "object") {
    const payload = error as ApiErrorPayload;
    const data = payload.response?.data ?? payload;

    if (typeof data.message === "string" && data.message.trim()) {
      return data.message;
    }

    if (
      typeof data.error_description === "string" &&
      data.error_description.trim()
    ) {
      return data.error_description;
    }

    if (typeof data.error === "string" && data.error.trim()) {
      return data.error.replace(/_/g, " ");
    }
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return fallback;
}
